export default "__VITE_ASSET__L0X3kFxE__"